import Vue from 'vue'
import Router from 'vue-router'
import PageView from '@/layouts/PageView'
import RouteView from '@/layouts/RouteView'
import GlobalLayout from '@/layouts/GlobalLayout'
import Login from '@/pages/login/Login'

Vue.use(Router)

export default new Router({
  scrollBehavior: () => {
    return { x: 0, y: 0 }
  },
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      invisible: true
    },
    {
      path: '/',
      name: 'Admin',
      component: GlobalLayout,
      redirect: '/login',
      icon: 'none',
      invisible: true,
      children: [
        {
          path: '/dashboard',
          name: 'Admin Dashboard',
          component: () => import('@/pages/dashboard/Dashboard'),
          icon: 'dashboard',
          meta: {
            permissions: ['admin']
          }
        },
        // Users
        {
          path: '/users',
          name: 'Users',
          component: PageView,
          redirect: '/users/user',
          icon: 'user',
          meta: {
            permissions: ['admin']
          },
          children: [
            {
              path: '/users/user',
              name: 'User',
              component: () => import('@/pages/users/UserList'),
              icon: 'none',
              meta: {
                permissions: ['admin']
              }
            },
            {
              path: '/users/add-edit-user/:user_id',
              name: 'Add Edit User',
              component: () => import(`@/pages/users/UserForm`),
              icon: 'none',
              meta: {
                permissions: ['admin']
              },
              invisible: true
            }
          ]
        },
        {
          path: '/master',
          name: 'Master',
          component: PageView,
          icon: 'home',
          meta: {
            permissions: ['admin']
          },
          children: [
            {
              path: '/master/document',
              name: 'Document',
              component: () => import('@/pages/master/Document/listDocument'),
              icon: 'none',
              meta: {
                permissions: ['admin']
              }
            },
            {
              path: '/master/add_document',
              name: 'Add Document',
              component: () => import(`@/pages/master/Document/addDocument`),
              icon: 'none',
              meta: {
                permissions: ['admin']
              },
              invisible: true
            },
            {
              path: '/master/edit_document/:doc_id',
              name: 'Edit Document',
              component: () => import(`@/pages/master/Document/editDocument`),
              icon: 'none',
              meta: {
                permissions: ['admin']
              },
              invisible: true
            },
            {
              path: '/master/visa-document-list',
              name: 'Visa Document',
              component: () =>
                import('@/pages/master/VisaDocument/VisaDocumentList'),
              icon: 'none',
              meta: {
                permissions: ['admin']
              }
            },
            {
              path: '/master/visa-document-form/:vdoc_id',
              name: 'Visa Document Form',
              component: () =>
                import(`@/pages/master/VisaDocument/VisaDocumentForm`),
              icon: 'none',
              meta: {
                permissions: ['admin']
              },
              invisible: true
            },
            {
              path: '/master/country',
              name: 'Country',
              component: () => import('@/pages/master/Country/listCountry'),
              icon: 'none',
              meta: {
                permissions: ['admin']
              }
            },
            {
              path: '/master/country_form/:country_id',
              name: 'Country Form',
              component: () => import(`@/pages/master/Country/countryForm`),
              icon: 'none',
              meta: {
                permissions: ['admin']
              },
              invisible: true
            },
            {
              path: '/master/state',
              name: 'State',
              component: () => import('@/pages/master/State/listState'),
              icon: 'none',
              meta: {
                permissions: ['admin']
              }
            },
            {
              path: '/master/add_state',
              name: 'Add State',
              component: () => import(`@/pages/master/State/addState`),
              icon: 'none',
              meta: {
                permissions: ['admin']
              },
              invisible: true
            },
            {
              path: '/master/edit_state/:state_id',
              name: 'Edit State',
              component: () => import(`@/pages/master/State/editState`),
              icon: 'none',
              meta: {
                permissions: ['admin']
              },
              invisible: true
            },
            {
              path: '/master/city',
              name: 'City',
              component: () => import('@/pages/master/City/listCity'),
              icon: 'none',
              meta: {
                permissions: ['admin']
              }
            },
            {
              path: '/master/add_city',
              name: 'Add City',
              component: () => import(`@/pages/master/City/addCity`),
              icon: 'none',
              meta: {
                permissions: ['admin']
              },
              invisible: true
            },
            {
              path: '/master/edit_city/:city_id',
              name: 'Edit City',
              component: () => import(`@/pages/master/City/editCity`),
              icon: 'none',
              meta: {
                permissions: ['admin']
              },
              invisible: true
            },
            {
              path: '/master/visa-checklist/',
              name: 'Visa Checklist',
              component: () =>
                import(`@/pages/master/VisaChecklist/VisaChecklistList`),
              icon: 'none',
              meta: {
                permissions: ['admin']
              },
              invisible: false
            },
            {
              path: '/master/visa-checklist-form/:vc_id',
              name: 'Visa Checklist Form',
              component: () =>
                import(`@/pages/master/VisaChecklist/VisaChecklistForm`),
              icon: 'none',
              meta: {
                permissions: ['admin']
              },
              invisible: true
            },
            {
              path: '/master/application-checklist/',
              name: 'Application Checklist',
              component: () =>
                import(
                  `@/pages/master/ApplicationChecklist/ApplicationChecklistList`
                ),
              icon: 'none',
              meta: {
                permissions: ['admin']
              },
              invisible: false
            },
            {
              path: '/master/application-checklist-form/:ac_id',
              name: 'Application Checklist Form',
              component: () =>
                import(
                  `@/pages/master/ApplicationChecklist/ApplicationChecklistForm`
                ),
              icon: 'none',
              meta: {
                permissions: ['admin']
              },
              invisible: true
            }
          ]
        },

        // Univeristy
        {
          path: '/university',
          name: 'University',
          component: PageView,
          redirect: '/university/list',
          icon: 'table',
          meta: {
            permissions: ['admin']
          },
          children: [
            {
              path: '/university/list',
              name: 'University List',
              component: () => import('@/pages/university/universityList'),
              icon: 'none',
              meta: {
                permissions: ['admin']
              }
            },
            {
              path: '/university/info-list',
              name: 'University Info List',
              component: () => import('@/pages/university/universityinfolist'),
              icon: 'none',
              meta: {
                permissions: ['admin']
              }
            },
            {
              path: '/university/info-form',
              name: 'University Info Form',
              component: () => import('@/pages/university/universityinfoform'),
              icon: 'none',
              meta: {
                permissions: ['admin']
              },
              invisible: true
            },
            {
              path: '/university/info-form/:mui_id',
              name: 'University Info Form',
              component: () => import('@/pages/university/universityinfoform'),
              icon: 'none',
              meta: {
                permissions: ['admin']
              },
              invisible: true
            },
            {
              path: '/university/form/:university_id',
              name: 'University Form',
              component: () => import(`@/pages/university/universityForm`),
              icon: 'none',
              meta: {
                permissions: ['admin']
              },
              invisible: true
            }
          ]
        },

        //Swed Univeristy
        {
          path: '/swed-university',
          name: 'Switz University',
          component: PageView,
          redirect: '/swed-university/list',
          icon: 'table',
          meta: {
            permissions: ['admin']
          },
          children: [
            {
              path: '/swed-university/list',
              name: 'Switz University List',
              component: () => import('@/pages/swed_university/universityList'),
              icon: 'none',
              meta: {
                permissions: ['admin']
              }
            },
            {
              path: '/swed-university/form/:university_id',
              name: 'Switz University Form',
              component: () => import(`@/pages/swed_university/universityForm`),
              icon: 'none',
              meta: {
                permissions: ['admin']
              },
              invisible: true
            }
          ]
        },

        // Course
        {
          path: '/course',
          name: 'Course',
          component: PageView,
          redirect: '/course/list',
          icon: 'table',
          meta: {
            permissions: ['admin']
          },
          children: [
            {
              path: '/course/list',
              name: 'Course List',
              component: () => import('@/pages/course/courseList'),
              icon: 'none',
              meta: {
                permissions: ['admin']
              }
            },
            {
              path: '/course/form/:course_id',
              name: 'Course Form',
              component: () => import(`@/pages/course/courseForm`),
              icon: 'none',
              meta: {
                permissions: ['admin']
              },
              invisible: true
            }
          ]
        },

        // Swed Course
        {
          path: '/swed-course',
          name: 'Switz Course',
          component: PageView,
          redirect: '/swed-course/list',
          icon: 'table',
          meta: {
            permissions: ['admin']
          },
          children: [
            {
              path: '/swed-course/list',
              name: 'Switz Course List',
              component: () => import('@/pages/swed_course/courseList'),
              icon: 'none',
              meta: {
                permissions: ['admin']
              }
            },
            {
              path: '/swed-course/form/:course_id',
              name: 'Switz Course Form',
              component: () => import(`@/pages/swed_course/courseForm`),
              icon: 'none',
              meta: {
                permissions: ['admin']
              },
              invisible: true
            }
          ]
        },

        // Sample Documents
        {
          path: '/sample_documents',
          name: 'Sample Documents',
          component: PageView,
          redirect: '/notification/list',
          icon: 'table',
          meta: {
            permissions: ['admin']
          },
          children: [
            {
              path: '/sample_documents/list',
              name: 'Sample Documents',
              component: () =>
                import('@/pages/SampleDocument/sampleDocumentList'),
              icon: 'none',
              meta: {
                permissions: ['admin']
              }
            },
            {
              path: '/sample_documents/form/:s_doc_id',
              name: 'Sample Documents Form',
              component: () =>
                import('@/pages/SampleDocument/sampleDocumentForm'),
              icon: 'none',
              meta: {
                permissions: ['admin']
              },
              invisible: true
            }
          ]
        },

        //Notifications
        {
          path: '/notification',
          name: 'Notification',
          component: PageView,
          redirect: '/notification/list',
          icon: 'table',
          meta: {
            permissions: ['admin']
          },
          children: [
            {
              path: '/notification/list',
              name: 'Notification List',
              component: () => import('@/pages/Notifications/listNotification'),
              icon: 'none',
              meta: {
                permissions: ['admin']
              }
            },
            {
              path: '/notification/form/:notification_id',
              name: 'Notification Form',
              component: () => import(`@/pages/Notifications/notificationForm`),
              icon: 'none',
              meta: {
                permissions: ['admin']
              },
              invisible: true
            },
            {
              path: '/notification/list-template',
              name: 'Template List',
              component: () =>
                import('@/pages/Notifications/Templates/ListTemplate'),
              icon: 'none',
              meta: {
                permissions: ['admin']
              }
            },
            {
              path: '/notification/list-template-form/:template_id',
              name: 'Template Form',
              component: () =>
                import(`@/pages/Notifications/Templates/EditTemplate`),
              icon: 'none',
              meta: {
                permissions: ['admin']
              },
              invisible: true
            },
            {
              path: '/text-editor',
              name: 'Editor',
              component: () => import('@/pages/Notifications/TextEditor.vue'),
              icon: 'none',
              meta: {
                permissions: ['admin']
              }
            }
          ]
        },

        {
          path: '/training',
          name: 'Training',
          component: PageView,
          icon: 'table',
          meta: {
            permissions: ['admin']
          },
          children: [
            {
              path: '/training/list',
              name: 'Training List',
              component: () => import('@/pages/training/trainingList'),
              icon: 'none',
              meta: {
                permissions: ['admin']
              }
            },
            {
              path: '/training/form/:tr_id',
              name: 'Training Form',
              component: () => import(`@/pages/training/trainingForm`),
              icon: 'none',
              meta: {
                permissions: ['admin']
              },
              invisible: true
            },
            {
              path: '/training/registered-list/:tr_id',
              name: 'Registered List',
              component: () => import(`@/pages/training/registeredList`),
              icon: 'none',
              meta: {
                permissions: ['admin']
              },
              invisible: true
            },
          ]
        },
        // Services
        {
          path: '/services',
          name: 'Services',
          component: PageView,
          icon: 'table',
          meta: {
            permissions: ['admin']
          },
          children: [
            {
              path: '/services/list',
              name: 'Services List',
              component: () => import('@/pages/Service/Services/listServices'),
              icon: 'none',
              meta: {
                permissions: ['admin']
              }
            },
            {
              path: '/services/form/:service_id',
              name: 'Service Form',
              component: () => import(`@/pages/Service/Services/serviceForm`),
              icon: 'none',
              meta: {
                permissions: ['admin']
              },
              invisible: true
            },
            {
              path: '/service_plan/list',
              name: 'Service Plans',
              component: () =>
                import('@/pages/Service/ServicePlans/listServicePlans'),
              icon: 'none',
              meta: {
                permissions: ['admin']
              }
            },
            {
              path: '/service_plan/form/:plan_id',
              name: 'Service Plan Form',
              component: () =>
                import(`@/pages/Service/ServicePlans/servicePlanForm`),
              icon: 'none',
              meta: {
                permissions: ['admin']
              },
              invisible: true
            }
          ]
        },
        {
          path: '/franchise',
          name: 'Franchise',
          component: PageView,
          icon: 'table',
          meta: {
            permissions: ['admin']
          },
          children: [
            {
              path: '/academy',
              name: 'Academy',
              component: () => import('@/pages/Franchise/Academy/academyList'),
              icon: 'none',
              meta: {
                permissions: ['admin']
              }
            },
            {
              path: '/franchise-trainings/list',
              name: 'Franchise Trainings List',
              component: () =>
                import('@/pages/Franchise/Trainings/trainingsList'),
              icon: 'none',
              meta: {
                permissions: ['admin']
              }
            },
            {
              path: '/franchise-trainings/form/:fa_id/:ft_id',
              name: 'Franchise Trainings Form',
              component: () =>
                import(`@/pages/Franchise/Trainings/trainingsForm`),
              icon: 'none',
              meta: {
                permissions: ['admin']
              },
              invisible: true
            },
            {
              path: '/academy/form/:fa_id',
              name: 'Franchise Academy Form',
              component: () => import(`@/pages/Franchise/Academy/academyForm`),
              icon: 'none',
              meta: {
                permissions: ['admin']
              },
              invisible: true
            },
            {
              path: '/franchise-trainings/:ft_id/add-edit-presentation/:ftp_id',
              name: 'Add Edit Presentation',
              component: () =>
                import(`@/pages/Franchise/Trainings/presentationForm`),
              icon: 'none',
              meta: {
                permissions: ['admin']
              },
              invisible: true
            },
            {
              path: '/franchise-trainings/:ft_id/add-edit-video/:video_id',
              name: 'Add Edit Video',
              component: () => import(`@/pages/Franchise/Trainings/videoForm`),
              icon: 'none',
              meta: {
                permissions: ['admin']
              },
              invisible: true
            },
            {
              path: '/franchise-trainings/response-list',
              name: 'Quiz Responses',
              component: () =>
                import('@/pages/Franchise/Trainings/responsesList'),
              icon: 'none',
              meta: {
                permissions: ['admin']
              }
            },
            {
              path: '/franchise-trainings/user-response-list/:user_id',
              name: 'User Responses',
              component: () =>
                import('@/pages/Franchise/Trainings/userResponse'),
              icon: 'none',
              meta: {
                permissions: ['admin']
              },
              invisible: true
            },
            // {
            //   path: '/franchise-marketing/list',
            //   name: 'Marketing Collateral List',
            //   component: () =>
            //     import(
            //       '@/pages/Franchise/MarketingCollateral/MarketingCollateralList'
            //     ),
            //   icon: 'none',
            //   meta: {
            //     permissions: ['admin']
            //   }
            // },
            // {
            //   path: '/franchise-marketing/form/:fmc_id',
            //   name: 'Marketing Collateral Form',
            //   component: () =>
            //     import(
            //       '@/pages/Franchise/MarketingCollateral/MarketingCollateralForm'
            //     ),
            //   icon: 'none',
            //   meta: {
            //     permissions: ['admin']
            //   },
            //   invisible: true
            // },
            {
              path: '/franchise-industry-news/list',
              name: 'Franchise Industry News List',
              component: () =>
                import('@/pages/Franchise/IndustryNews/IndustryNewsList'),
              icon: 'none',
              meta: {
                permissions: ['admin']
              }
            },
            {
              path: '/franchise-industry-news/form/:fin_id',
              name: 'Franchise Industry News Form',
              component: () =>
                import('@/pages/Franchise/IndustryNews/IndustryNewsForm'),
              icon: 'none',
              meta: {
                permissions: ['admin']
              },
              invisible: true
            },
            {
              path: '/franchise-material/list',
              name: 'Franchise Material List',
              component: () =>
                import('@/pages/Franchise/Material/MaterialList'),
              icon: 'none',
              meta: {
                permissions: ['admin']
              }
            },
            {
              path: '/franchise-material/form/:fm_id',
              name: 'Franchise Material Form',
              component: () =>
                import('@/pages/Franchise/Material/MaterialForm'),
              icon: 'none',
              meta: {
                permissions: ['admin']
              },
              invisible: true
            }
          ]
        },
        {
          path: '/carreer-jobs',
          name: 'Career Jobs',
          component: PageView,
          icon: 'table',
          meta: {
            permissions: ['admin']
          },
          children: [
            {
              path: '/carreer-jobs/list',
              name: 'Jobs List',
              component: () => import('@/pages/careers/Careerlist'),
              icon: 'none',
              meta: {
                permissions: ['admin']
              }
            },
            {
              path: '/career-jobs/form/:cj_id',
              name: 'Job Form',
              component: () => import(`@/pages/careers/CareerForm`),
              icon: 'none',
              meta: {
                permissions: ['admin']
              },
              invisible: true
            }
            // {
            //   path: '/franchise-trainings/response-list',
            //   name: 'Responses',
            //   component: () => import('@/pages/FranchiseTraining/responsesList'),
            //   icon: 'none',
            //   meta: {
            //     permissions: ['admin']
            //   }
            // },
          ]
        },
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js